import React from 'react';
import { Palette, Zap, Share2, Coins, Dices } from 'lucide-react';

const HowToPlay: React.FC = () => {
  const steps = [
    {
      id: 1,
      title: "Design Your Crate",
      desc: "Name your lootbox. During Season 1, all rewards are paid in $BLOOT from the project treasury. Be creative—this is your product.",
      icon: <Palette size={32} color="white" />
    },
    {
      id: 2,
      title: "Generate Blink",
      desc: "We deploy a lightweight contract and give you a unique Solana Blink link instantly.",
      icon: <Zap size={32} color="white" />
    },
    {
      id: 3,
      title: "Share Everywhere",
      desc: "Post your Blink on X (Twitter). Users can play directly from their feed without leaving the app.",
      icon: <Share2 size={32} color="white" />
    },
    {
      id: 4,
      title: "Earn Fees",
      desc: "You collect a 2% fee on every single spin. The more people play, the more you earn.",
      icon: <Coins size={32} color="white" />
    },
    {
      id: 5,
      title: "Fair & Random",
      desc: "All outcomes are provably fair and verifiable on-chain. No rug pulls, just pure RNG.",
      icon: <Dices size={32} color="white" />
    }
  ];

  return (
    <div className="how-to-play-container">
      <div className="section-header">
        <h3>How It Works</h3>
        <p className="section-desc">Turn social engagement into revenue in 5 simple steps.</p>
      </div>
      
      <div className="steps-grid">
        {steps.map((step, index) => (
          <div key={step.id} className="instruction-card" style={{ animationDelay: `${index * 0.1}s` }}>
            <div className="card-header">
              <span className="step-number">0{step.id}</span>
              <span className="step-icon">{step.icon}</span>
            </div>
            <h4>{step.title}</h4>
            <p>{step.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HowToPlay;
